module.exports = __webpack_public_path__ + "img/whatsapp.0987fc50.svg";